import React, { useEffect } from "react";
import withContext from "../../utils/withContext";

export const AdFoxAdaptive = ({ options, context, cls = true, className = "adfox" }) => {
    const first = options && options[0];

    useEffect(() => {
        if (!first || typeof window === "undefined" || !window.yaContextCb) {
            return;
        }

        // Копируем и сам элемент, и params: `[...options]` копирует только массив,
        // поэтому запись partner-stat-id уходила в объект исходного конфига.
        // С конфигом из window.initial это была бы мутация общего состояния страницы.
        // Спред отсутствующего params даёт {}, поэтому yandex-payload больше не падает
        // на `Cannot set properties of undefined (setting 'partner-stat-id')`.
        const opts = [
            { ...first, params: { ...first.params, "partner-stat-id": context.uniq_id } },
            ...options.slice(1),
        ];

        window.yaContextCb.push(() => {
            window.Ya.adfoxCode.create(...opts);
        });
    }, [options, context.uniq_id]);

    if (!first) {
        return null;
    }

    return <div id={first.containerId} {...(cls ? { className: className } : {})} />;
};

export default withContext(AdFoxAdaptive);
